export default {
  "/": {
    "en": "/",
    "zh": "/",
    "ko": "/",
    "ja": "/",
    "pt-br": "/",
    "es": "/",
    "de": "/",
    "fr": "/",
    "it": "/"
  },
  "/login": {
    "en": "/login",
    "zh": "/login",
    "ko": "/login",
    "ja": "/login",
    "pt-br": "/login",
    "es": "/login",
    "de": "/login",
    "fr": "/login",
    "it": "/login"
  },
  "/privacy-policy": {
    "en": "/privacy-policy",
    "zh": "/privacy-policy",
    "ko": "/privacy-policy",
    "ja": "/privacy-policy",
    "pt-br": "/politica-de-privacidade",
    "es": "/politica-de-privacidad",
    "de": "/datenschutz",
    "fr": "/politique-de-confidentialite",
    "it": "/politica-sulla-privacy"
  },
  "/pronunciation-assessment": {
    "en": "/pronunciation-assessment",
    "zh": "/pronunciation-assessment",
    "ko": "/pronunciation-assessment",
    "ja": "/pronunciation-assessment",
    "pt-br": "/avaliacao-de-pronuncia",
    "es": "/evaluacion-de-pronunciacion",
    "de": "/aussprachebewertung",
    "fr": "/evaluation-de-prononciation",
    "it": "/valutazione-della-pronuncia"
  },
  "/study": {
    "en": "/study",
    "zh": "/study",
    "ko": "/study",
    "ja": "/study",
    "pt-br": "/estudar",
    "es": "/estudiar",
    "de": "/studieren",
    "fr": "/etudier",
    "it": "/studiare"
  },
  "/study/account": {
    "en": "/study/account",
    "zh": "/study/account",
    "ko": "/study/account",
    "ja": "/study/account",
    "pt-br": "/estudar/conta",
    "es": "/estudiar/cuenta",
    "de": "/studieren/konto",
    "fr": "/etudier/compte",
    "it": "/studiare/conto"
  },
  "/study/listening": {
    "en": "/study/listening",
    "zh": "/study/listening",
    "ko": "/study/listening",
    "ja": "/study/listening",
    "pt-br": "/estudar/ouvir",
    "es": "/estudiar/escuchar",
    "de": "/studieren/horen",
    "fr": "/etudier/ecouter",
    "it": "/studiare/ascoltare"
  },
  "/study/listening/exercise": {
    "en": "/study/listening/exercise",
    "zh": "/study/listening/exercise",
    "ko": "/study/listening/exercise",
    "ja": "/study/listening/exercise",
    "pt-br": "/estudar/ouvir/exercicio",
    "es": "/estudiar/escuchar/ejercicio",
    "de": "/studieren/horen/uebung",
    "fr": "/etudier/ecouter/exercice",
    "it": "/studiare/ascoltare/esercizi"
  },
  "/study/reading": {
    "en": "/study/reading",
    "zh": "/study/reading",
    "ko": "/study/reading",
    "ja": "/study/reading",
    "pt-br": "/estudar/leitura",
    "es": "/estudiar/lectura",
    "de": "/studieren/lesen",
    "fr": "/etudier/lecture",
    "it": "/studiare/lettura"
  },
  "/study/reading/exercise": {
    "en": "/study/reading/exercise",
    "zh": "/study/reading/exercise",
    "ko": "/study/reading/exercise",
    "ja": "/study/reading/exercise",
    "pt-br": "/estudar/leitura/exercicio",
    "es": "/estudiar/lectura/ejercicio",
    "de": "/studieren/lesen/uebung",
    "fr": "/etudier/lecture/exercice",
    "it": "/studiare/lettura/esercizi"
  },
  "/study/speaking": {
    "en": "/study/speaking",
    "zh": "/study/speaking",
    "ko": "/study/speaking",
    "ja": "/study/speaking",
    "pt-br": "/estudar/fala",
    "es": "/estudiar/habla",
    "de": "/studieren/sprechen",
    "fr": "/etudier/parler",
    "it": "/studiare/parlare"
  },
  "/study/speaking/chat": {
    "en": "/study/speaking/chat",
    "zh": "/study/speaking/chat",
    "ko": "/study/speaking/chat",
    "ja": "/study/speaking/chat",
    "pt-br": "/estudar/fala/chat",
    "es": "/estudiar/habla/chat",
    "de": "/studieren/sprechen/chat",
    "fr": "/etudier/parler/chat",
    "it": "/studiare/parlare/chat"
  },
  "/study/speaking/pronunciation": {
    "en": "/study/speaking/pronunciation",
    "zh": "/study/speaking/pronunciation",
    "ko": "/study/speaking/pronunciation",
    "ja": "/study/speaking/pronunciation",
    "pt-br": "/estudar/fala/pronuncia",
    "es": "/estudiar/habla/pronunciacion",
    "de": "/studieren/sprechen/aussprache",
    "fr": "/etudier/parler/prononciation",
    "it": "/studiare/parlare/pronuncia"
  },
  "/study/stats": {
    "en": "/study/stats",
    "zh": "/study/stats",
    "ko": "/study/stats",
    "ja": "/study/stats",
    "pt-br": "/estudar/estatisticas",
    "es": "/estudiar/estadisticas",
    "de": "/studieren/statistiken",
    "fr": "/etudier/statistiques",
    "it": "/studiare/statistiche"
  },
  "/study/writing": {
    "en": "/study/writing",
    "zh": "/study/writing",
    "ko": "/study/writing",
    "ja": "/study/writing",
    "pt-br": "/estudar/escrita",
    "es": "/estudiar/escritura",
    "de": "/studieren/schreiben",
    "fr": "/etudier/ecriture",
    "it": "/studiare/scrittura"
  },
  "/study/writing/chat": {
    "en": "/study/writing/chat",
    "zh": "/study/writing/chat",
    "ko": "/study/writing/chat",
    "ja": "/study/writing/chat",
    "pt-br": "/estudar/escrita/chat",
    "es": "/estudiar/escritura/chat",
    "de": "/studieren/schreiben/chat",
    "fr": "/etudier/ecriture/chat",
    "it": "/studiare/scrittura/chat"
  },
  "/study/writing/ghost": {
    "en": "/study/writing/ghost",
    "zh": "/study/writing/ghost",
    "ko": "/study/writing/ghost",
    "ja": "/study/writing/ghost",
    "pt-br": "/estudar/escrita/fantasma",
    "es": "/estudiar/escritura/fantasma",
    "de": "/studieren/schreiben/gespenst",
    "fr": "/etudier/ecriture/fantome",
    "it": "/studiare/scrittura/fantasma"
  },
  "/terms-of-service": {
    "en": "/terms-of-service",
    "zh": "/terms-of-service",
    "ko": "/terms-of-service",
    "ja": "/terms-of-service",
    "pt-br": "/termos-de-servico",
    "es": "/terminos-de-servicio",
    "de": "/nutzungsbedingungen",
    "fr": "/conditions-generales-d-utilisation",
    "it": "/termini-di-servizio"
  },
  "/welcome": {
    "en": "/welcome",
    "zh": "/welcome",
    "ko": "/welcome",
    "ja": "/welcome",
    "pt-br": "/boas-vindas",
    "es": "/bienvenido",
    "de": "/willkommen",
    "fr": "/bienvenue",
    "it": "/benvenuto"
  }
}